module.exports = __webpack_public_path__ + "static/media/page3_furba5.3f784c87.wav";